import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterVideoCategoryPipe } from 'src/app/pipe/filter-video-category.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { VideoCardSharedModule } from '../video-card-shared/video-card-shared.module';
import { HomepageSliderComponent } from './components/homepage-slider/homepage-slider.component';
import { HomepageComponent } from './components/homepage/homepage.component';
import { HowworksComponent } from './components/how-it-works-browse-category-nav/howitworks.component';
import { HowitsworkHomepageComponent } from './components/howitswork-homepage/howitswork-homepage.component';
import { TrendingInvitesComponent } from './components/trending-invites/trending-invites.component';
import { UserReviewDetailsComponent } from './components/user-review-details/user-review-details.component';
import { UserReviewComponent } from './components/user-review/user-review.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HomePageRouting } from './home-page-routing.module';
import { FilterVideoCategoryDescriptionPipe } from 'src/app/pipe/filter-video-category-description.pipe';
import { AllCategoriesComponent } from './components/all-categories/all-categories.component';
import { HowItWorksDialogComponent } from './components/how-it-works-dialog/how-it-works-dialog.component';
import { PremiumInviteDialogComponent } from './components/premium-invite-dialog/premium-invite-dialog.component';

@NgModule({
  declarations: [
    HomepageComponent,
    HomepageSliderComponent,
    HowworksComponent,
    HowitsworkHomepageComponent,
    FilterVideoCategoryPipe,
    TrendingInvitesComponent,
    UserReviewComponent,
    UserReviewDetailsComponent,
    AllCategoriesComponent,
    FilterVideoCategoryDescriptionPipe,
    HowItWorksDialogComponent,
    PremiumInviteDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    VideoCardSharedModule,
    CarouselModule,
    HomePageRouting
  ]
})
export class HomePageModule { }
